import { FC } from "react";
import { useOutletContext } from "react-router-dom";
import { UserPageOutletContext } from "../index";
import { UserVehicleControlTabContent } from "./content";

export const UserVehicleControlTab: FC<any> = () => {
  const [user] = useOutletContext<UserPageOutletContext>();
  return <UserVehicleControlTabContent user={user} />;
};
